function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';

/**
 * Cell renderer for totals row in DataGrid
 * 
 * @param {Object} props
 * @param {string} props.headerText - The header text to lookup in totalsRow
 * @param {Object} props.totalsRow - Hash mapping of header text to display value
 * @param {Object} props.style - Optional additional styles
 * @returns {JSX.Element}
 */
export function TotalsCell(_ref) {
  var _totalsRow$headerText;
  let {
    headerText,
    totalsRow,
    style = {}
  } = _ref;
  const value = (_totalsRow$headerText = totalsRow === null || totalsRow === void 0 ? void 0 : totalsRow[headerText]) !== null && _totalsRow$headerText !== void 0 ? _totalsRow$headerText : '';
  return /*#__PURE__*/React.createElement("div", {
    className: "DataGridTable-totals-cell",
    style: _objectSpread({
      fontWeight: 'bold',
      textAlign: 'right',
      padding: '4px 8px'
    }, style)
  }, value || '-');
}